
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#3B3C3A","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","stroke":"#000"}},[_c('g',{attrs:{"stroke-width":"1.5","fill":"none"}},[_c('path',{attrs:{"d":"M16.5 4.833l-7.628 10.17a1 1 0 01-1.507.108L5.38 13.126M5 15.173a1 1 0 01-1.422.008L1.593 13.2M12.62 4.903l-5.427 7.236"}})]),_c('g',{attrs:{"stroke-width":"1.5","fill":"none"}},[_c('path',{attrs:{"d":"M5 1.499v7M8.5 4.999h-7M7.475 2.524l-4.95 4.95M7.475 7.474l-4.95-4.95"}})])])])
          )
        }
      }
    